const e = {
  adPrice: "R$ 14900",
  percentageFromMedianPrice: 10,
  quartile: 1,
  quartileColors: {
    highlighted: ["var(--color-feedback-info-90)", "var(--color-feedback-info-100)", "var(--color-feedback-info-110)"],
    normal: ["var(--color-feedback-info-90)", "var(--color-feedback-info-100)", "var(--color-feedback-info-110)"]
  },
  olxPrice: {
    price_p50: 17500,
    price_max: 3e4,
    price_min: 1e4,
    price_p33: 15e3,
    price_p66: 2e4
  },
  hideWithoutPriceInput: !1
};
export { e as priceReferenceRulerDefaultProps };